import Link from 'next/link'
import React from 'react'
import { Icon } from '@/components/icon'
import { faAnglesRight } from '@fortawesome/free-solid-svg-icons'

interface BreadcrumbProps {
  crumbs: {
    name: string
    route: string
    active?: boolean
  }[]
}

export const BreadcrumbsComponent: React.FC<BreadcrumbProps> = (props) => {
  return (
    <nav className="flex items-center" aria-label="Breadcrumb">
      <ol className="mb-0 flex items-center">
        {props.crumbs.map((crumb, idx) => (
          <div key={`${crumb.name}-${idx}`} className="flex items-center">
            {idx != 0 && (
              <div className="mr-1 ml-1">
                <Icon icon={faAnglesRight} />
              </div>
            )}
            <li className="inline-flex items-center">
              <Link
                href={crumb.route}
                className="inline-flex items-center text-sm font-medium text-gray-500 hover:text-[#39769F]"
                key={crumb.route}
              >
                {crumb.name}
              </Link>
            </li>
          </div>
        ))}
      </ol>
    </nav>
  )
}

BreadcrumbsComponent.displayName = 'Breadcrumbs'

export const Breadcrumbs = React.memo(BreadcrumbsComponent)
